export default "__VITE_ASSET__Cqo64Jv3__"